import { select } from 'redux-saga/effects'

import selectors from '../selectors'
import { focusLauncher } from './frameUtilities'

export default function* closePico() {
    const isPicoDisplayed = yield select(selectors.isPicoDisplayed)

    if (isPicoDisplayed) {
        yield focusLauncher()
    }
}
